module.exports = "https://static.wmbcdn.com/uniweb/images/e94bbfe57b50c4e0e589eda933242274.svg";